import React from "react";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import { ShieldCheckIcon, LockIcon, XCircleIcon, CheckCircleIcon } from "@phosphor-icons/react";

export default function Policy() {
  return (
    <div className="min-h-screen bg-white flex flex-col" data-testid="policy-page">
      <Navbar />
      <main className="flex-1 max-w-4xl mx-auto w-full px-6 py-16">
        <h1 className="font-display font-black text-5xl lg:text-6xl tracking-tighter">
          The rules. Zero exceptions.
        </h1>
        <p className="mt-6 text-lg text-zinc-700 max-w-2xl leading-relaxed">
          Bidorah is the first live-auction marketplace that operates two fully-separate commerce lanes:
          retail and wholesale. Sellers and buyers in those lanes never transact across.
          This is not a preference — it's a structural rule of the platform.
        </p>

        <div className="mt-10 grid md:grid-cols-2 gap-4">
          <div className="border border-zinc-200 bg-white p-6">
            <div className="flex items-center gap-2 mb-3">
              <LockIcon size={22} className="text-[#1D78AB]" />
              <p className="overline text-zinc-500">ENFORCEMENT</p>
            </div>
            <p className="font-display font-bold text-xl">Enforced at every layer</p>
            <ul className="mt-3 space-y-2 text-sm text-zinc-700 leading-relaxed">
              <li>• Account type is chosen at signup and <b>is permanent</b>.</li>
              <li>• Every listing is tagged with its segment.</li>
              <li>• Checkout blocks any segment mismatch at the API level.</li>
              <li>• Bids on auctions check segment before accepting.</li>
              <li>• Mixed carts are not possible. We do not build workarounds.</li>
            </ul>
          </div>
          <div className="border border-zinc-200 bg-white p-6">
            <div className="flex items-center gap-2 mb-3">
              <ShieldCheckIcon size={22} className="text-[#1D78AB]" />
              <p className="overline text-zinc-500">WHY</p>
            </div>
            <p className="font-display font-bold text-xl">Two very different economics</p>
            <p className="mt-3 text-sm text-zinc-700 leading-relaxed">
              Wholesale pricing, tax treatment, minimum quantities, shipping logistics, and
              resale regulation are distinct from retail. Blending them harms both sides.
              Bidorah refuses to compromise the integrity of either market.
            </p>
          </div>
        </div>

        <div className="mt-10 grid md:grid-cols-2 gap-4">
          <div className="border border-red-300 bg-red-50 p-6">
            <div className="flex items-center gap-2 mb-3">
              <XCircleIcon size={22} className="text-red-600" />
              <p className="overline text-red-700">NOT ALLOWED</p>
            </div>
            <ul className="text-sm text-zinc-800 space-y-2">
              <li>× Wholesale sellers cannot sell to retail buyers.</li>
              <li>× Retail sellers cannot sell to wholesale buyers.</li>
              <li>× Accounts cannot change their segment after signup.</li>
              <li>× Users cannot operate two accounts across segments.</li>
              <li>× No "hybrid" cart, no "just this once" exception.</li>
            </ul>
          </div>
          <div className="border border-emerald-300 bg-emerald-50 p-6">
            <div className="flex items-center gap-2 mb-3">
              <CheckCircleIcon size={22} className="text-emerald-600" />
              <p className="overline text-emerald-700">ALLOWED</p>
            </div>
            <ul className="text-sm text-zinc-800 space-y-2">
              <li>✓ Retail buyer ↔ Retail seller</li>
              <li>✓ Wholesale buyer ↔ Wholesale seller</li>
              <li>✓ Transparent browsing (you can see the other side, you just can't transact with it).</li>
              <li>✓ Verified US government-issued photo ID for everyone.</li>
            </ul>
          </div>
        </div>

        <div className="mt-12 border-t border-zinc-200 pt-8 text-sm text-zinc-600">
          <p>
            <b className="text-zinc-900">Violation policy:</b> Users attempting to circumvent segment
            separation (e.g., funneling purchases through a proxy) are removed from Bidorah and may be reported
            to payment processors. Enforcement is not discretionary.
          </p>
        </div>
      </main>
      <Footer />
    </div>
  );
}
